import React, { useState } from 'react';
import 'twin.macro';
import { UserLocale } from 'types/user';
import { useFormState } from 'react-final-form';
import { AppelsStatsPDFSettings } from '../../Print/types';
import { buildAppelsStatsPDFParams } from 'containers/RegistreAppel/Preview/Stats/Sidebar/buildAppelsStatsPDFParams';
import { useSendUpdateParamsToIframe } from 'components/Iframe/useSendUpdateParamsToIframe';
import { IframePreviewPDF } from 'components/Print/IframePreviewPDF';

interface Props {
  schoolyearId: string;
  schoolId: string;
  from: Date;
  to: Date;
  eleveId?: string;
  lng: UserLocale;
  tz: string;
}

export function Body(props: Props) {
  const { schoolyearId, schoolId, from, to, eleveId, lng, tz } = props;
  const { values } = useFormState<AppelsStatsPDFSettings>();

  const url = new URL(
    eleveId
      ? `/print/annee-scolaire/${schoolyearId}/ecole/${schoolId}/eleves/${eleveId}/presences`
      : `/print/annee-scolaire/${schoolyearId}/ecole/${schoolId}/appels/stats`,
    window.location.origin,
  );
  url.search = buildAppelsStatsPDFParams({
    from,
    to,
    eleveId,
    lng,
    tz,
    settings: values,
  }).toString();

  const [urlAsString] = useState(url.toString());

  const { iframeRef } = useSendUpdateParamsToIframe({
    url,
    search: buildAppelsStatsPDFParams({
      from,
      to,
      eleveId,
      lng,
      tz,
      settings: values,
    }),
  });

  return (
    <IframePreviewPDF onePage iframeUrl={urlAsString} iframeRef={iframeRef} />
  );
}
